import React from 'react'
import { Label } from '@progress/kendo-react-labels'
import TooltipHLPure from '../tooltipHL/tooltipHL.pure'
import "./labelHLPure.css";

const LabelHLPure = (props) => {

    let {
        text,
        fontSize = '14px',
        showTooltip,
        positionTooltip,
        titleTooltip,
        descriptionTooltip,
        subContent,
        restContent,
        informationIcon,
    } = props

    return(
        <div className='labelHLPure-container'>
            <Label className='labelHLPure-label' style={{fontSize:fontSize}}>
                {text}
            </Label>
            {
                showTooltip && (
                    <div className='labelHLPure-tooltip'>
                        <TooltipHLPure
                            {...props}
                            positionTooltip={positionTooltip}
                            titleTooltip={titleTooltip}
                            descriptionTooltip={descriptionTooltip}
                            subContent={subContent}
                            restContent={restContent}
                            informationIcon={informationIcon}
                        />
                    </div>
                )
            }
        </div>
    )
}

export { LabelHLPure as default }